import { IFilterDate, IFormController } from "angular";
import { IFieldArray, IFormOptionsAPI } from "AngularFormly";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../../../records/server/serverUtility";
import { IReportGroup } from "../../../../../reporting/interfaces/IReportGroup";
import fieldHelpers from "../../../../../ui-formly/fieldHelpers";

type FormInfo = {
  editing: boolean;
  form: IFormController;
  formlyOptions: IFormOptionsAPI;
};

export class MachinesDetailProgressiveConfigurationViewController {
  static $inject = [
    "date",
    "machineHistory",
    "dateFilter",
    "progressiveDefinitionLookup",
    ServerUtilityName,
    "progressiveReportGroup",
    "currencyFilter",
  ];

  startDate: Date | undefined;
  endDate: Date | undefined;
  startDateCalendarOpened = false;
  endDateCalendarOpened = false;
  readonly machineNotesFields: IFieldArray = [
    fieldHelpers.textAreaField({
      key: "Notes",
      name: "Notes",
      label: "Notes",
      rows: 5,
    }),
  ];

  constructor(
    private readonly date: Date,
    readonly machineHistory: any,
    private readonly dateFilter: IFilterDate,
    readonly progressiveDefinitionLookup: any,
    private readonly serverUtility: ServerUtility,
    readonly progressiveReportGroup: IReportGroup,
    private readonly currencyFilter: (...args: any[]) => string
  ) {}

  getMachineChanges() {
    return this.machineHistory.MachineChanges.filter(
      (mc: any) =>
        (this.startDate === undefined || mc.Date >= this.startDate) &&
        (this.endDate === undefined || mc.Date <= this.endDate)
    );
  }

  filterChanged() {}

  clearFilters() {
    this.startDate = this.endDate = undefined;
  }

  setFormOpen(formInfo: FormInfo, open: boolean) {
    formInfo.editing = open;
  }

  getAccordionHeading(machineChange: any) {
    const configuration = machineChange.MachineConfiguration;
    const configurationDate: Date = machineChange.Date;
    const systemDate: Date = this.date;
    const currentConfiguration: boolean = configuration.CurrentConfiguration;

    const futureChange = configurationDate > systemDate;
    const changeTypeDetail = configuration.ConversionTypeName
      ? `(${configuration.ConversionTypeName})`
      : "";
    const progressiveCount =
      this.progressiveDefinitionLookup[configuration.Id]?.length ?? 0;

    return `${machineChange.ChangeType}${changeTypeDetail} - ${this.dateFilter(
      configurationDate
    )}${currentConfiguration && !futureChange ? " - Current" : ""}${
      futureChange ? " - Pending" : ""
    } - ${progressiveCount} progressives`;
  }

  submitForm(formInfo: FormInfo, progressiveDefinitionMachine: any) {
    this.serverUtility
      .patch({
        url: "/api/machines/progressives/ProgressiveDefinitionMachine",
        patchObject: {
          Id: progressiveDefinitionMachine.Id,
          Notes: progressiveDefinitionMachine.Notes,
        },
      })
      .then(() => {
        this.setFormOpen(formInfo, false);
      });
  }

  cancelForm(formInfo: FormInfo) {
    formInfo.formlyOptions.resetModel?.call(undefined);
    this.setFormOpen(formInfo, false);
  }

  getCeilingDisplay(ceiling?: number) {
    return ceiling ? this.currencyFilter(ceiling, "$", 2) : "N/A";
  }
}
